import React from "react";
import { Route, Switch } from "react-router-dom";
import Irdashboard from "./IndentRequestDashboard/Irdashboard";
import Vtdashboard from "./IndentTrackingDashboard/Vtdashboard";

const DashboardRouting = () => {
  return (
    <Switch>
      <Route path="/indents/requestdashboard" component={Irdashboard} exact />
      <Route path="/indents/trackingdashboard" component={Vtdashboard} exact />
    </Switch>
  );
};

export default DashboardRouting;
